import React from "react";
import "./Estimate1.css"; // Make sure to add your CSS here
import image3 from "../../../images/Aziz_sign-stamp-png (002).png";
import image4 from "../../../images/EstimateCertified.png";
import image5 from "../../../images/EstimateCMP.png";
import "@fortawesome/fontawesome-free/css/all.min.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const Estimate1 = () => {
  const data = [
    {
      id: 1,
      description: "NOC DOCUMENTATION (EXPORT/IMPORT)",
      hsn: "123456",
      qty: 1,
      amount: 15000,
      gst: 2700,
      total: '10,00,000.00',
    },
    {
      id: 2,
      description: "ANOTHER ITEM",
      hsn: "123456",
      qty: 2,
      amount: 10000,
      gst: 1800,
      total: 11800,
    },
    {
      id: 3,
      description: "THIRD ITEM",
      hsn: "123456",
      qty: 1,
      amount: 5000,
      gst: 900,
      total: 5900,
    },
    {
      id: 4,
      description: "FOURTH ITEM",
      hsn: "123456",
      qty: 3,
      amount: 3000,
      gst: 540,
      total: 3540,
    },
    {
      id: 5,
      description: "FIFTH ITEM",
      hsn: "123456",
      qty: 2,
      amount: 8000,
      gst: 1440,
      total: 9440,
    },
    {
      id: 6,
      description: "NOC DOCUMENTATION (EXPORT/IMPORT)",
      hsn: "123456",
      qty: 1,
      amount: 15000,
      gst: 2700,
      total: 17700,
    },
    {
      id: 7,
      description: "ANOTHER ITEM",
      hsn: "123456",
      qty: 2,
      amount: 10000,
      gst: 1800,
      total: 11800,
    },
    {
      id: 8,
      description: "THIRD ITEM",
      hsn: "123456",
      qty: 1,
      amount: 5000,
      gst: 900,
      total: 5900,
    },
    {
      id: 9,
      description: "FOURTH ITEM",
      hsn: "123456",
      qty: 3,
      amount: 3000,
      gst: 540,
      total: 3540,
    },
    {
      id: 10,
      description: "FIFTH ITEM",
      hsn: "123456",
      qty: 2,
      amount: 8000,
      gst: 1440,
      total: 9440,
    },
    {
      id: 11,
      description: "FIFTH ITEM",
      hsn: "123456",
      qty: 2,
      amount: 8000,
      gst: 1440,
      total: 9440,
    },
  ];
  const downloadAsPDF = () => {
    const input = document.getElementById("pdf-content");

    html2canvas(input, { scale: 2 }) // Increased scale for better quality
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.7);
        const pdf = new jsPDF("p", "mm", "a4");

        const pageWidth = pdf.internal.pageSize.width;
        const pageHeight = pdf.internal.pageSize.height;
        const contentHeight = (canvas.height * pageWidth) / canvas.width;

        let position = 0;
        let remainingHeight = contentHeight;

        while (remainingHeight > 0) {
          pdf.addImage(imgData, "JPEG", 0, position, pageWidth, contentHeight);
          position -= pageHeight;
          remainingHeight -= pageHeight;
          if (remainingHeight > 0) pdf.addPage();
        }

        pdf.save("Estimate.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };
  return (
    <>
      <div id="pdf-content" className="estimate-container">
        <div className="header1">
          <div className="billing-details billing-details-bottom">
            <div className="left Estimate-leftP">
              <h1>ESTIMATE</h1>
              <p>
                <strong>Billing Name:</strong> DBW Worldwide Pvt. Ltd
              </p>
              <p>
                <strong>Address:</strong> 2nd Floor, Plot No. 269, Phase IV,{" "}
                <br />
                Udyog Vihar, Sector 18, Gurugram, Haryana 122015
              </p>
              <p>
                <strong>Company ID:</strong> U63030DL2017PTC319496
              </p>
              <p>
                <strong>PAN:</strong> AAHCD9235R
              </p>

              <p>
                <strong>GSTIN:</strong> 07AAHCD9235F1ZI
              </p>
            </div>
          </div>

          <div className="header-right">
            <div
              className="logo-container logo-container-wigth"
              style={{ width: "278px" }}
            >
              <img
                style={{ width: "14pc", height: "129px", marginLeft: "38px" }}
                src={image5}
                alt="Logo"
                className="logo logo-container-wigth-img"
              />
            </div>
            <p
              style={{
                marginBottom: "-13px",
                fontSize: "8px",
                padding: "4px",
                fontWeight: "700",
              }}
            >
              Certified by:
            </p>
            <img
              style={{ width: "10pc", padding: "5px" }}
              src={image4}
              alt="Certification"
              className="certification logo-container-wigth-img1"
            />
          </div>
        </div>

        <div
          className="estimate-details-container"
          style={{
            backgroundColor: "#f0f0f0",
            padding: "3px 15px",
            borderRadius: "5px",
          }}
        >
          <table
            className="details-table td-font-famliy"
            style={{ width: "100%", border: "none" }}
          >
            <tbody>
              <tr>
                <td colSpan={5} style={{ paddingRight: "34.6px" }}>
                  <table
                    style={{
                      width: "100%",
                      lineHeight: "0.6",
                      marginTop: "0px",
                    }}
                  >
                    <tbody>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Lead ID</span> :
                          12345
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Pet Owner Name</span>{" "}
                          : Mahesh Jaiswal
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Number Of Pets</span>{" "}
                          : 10
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Service Type</span> :
                          Domestic Air
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Delivery Type</span>{" "}
                          : Door-to-Door
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Estimate</span> :
                          EST-12345
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Estimate No</span> :
                          24 Oct 2024
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Expiry Date</span> :
                          28 Oct 2024
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Est Created By</span>{" "}
                          : Sonali Gakhar
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  colSpan={5}
                  style={{
                    borderLeft: "1px solid #6A6A6B",
                    paddingLeft: "15px",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      lineHeight: "0.6",
                      margin: "0 0 0 ",
                    }}
                  >
                    <tbody>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">
                            Place Of Supply
                          </span>{" "}
                          : London (07)
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Origin Airport</span>{" "}
                          : London-Heathrow Airport
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">
                            Destination Airport
                          </span>{" "}
                          : Delhi-Airport
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Origin City</span> :
                          London
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">
                            Destination City
                          </span>{" "}
                          : Delhi
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Mode</span> : Air
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Airline Name</span> :
                          Air Alaska
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">
                            Chargeable Weight in KG
                          </span>{" "}
                          : 147 Kg
                        </td>
                      </tr>
                      <tr className="TrBackColor">
                        <td>
                          <span className="fontweightbold">Crate Size</span> :
                          32 (32*23*24) inches
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="address-container">
          <div
            className="address-item"
            style={{ width: "47.5%", borderRight: "1px solid rgb(106, 106, 106)" }}
          >
            <h3>
              Bill To: <span>Mahesh Jaiswal</span>
            </h3>
            <p>41 Manchester Road London N80 1LD</p>
            <p style={{ color: "white" }}>dont dont</p>
          </div>
          {/* Vertical line separator */}
          {/* <div className="vertical-line"></div> */}

          <div className="address-item address-item-change">
            <h3>
              Ship To: <span>Areesha Akhtar</span>
            </h3>
            <p>
              2nd Floor, Plot No. 269, Phase IV, Udyog Vihar, Sector 18, New
              Delhi, Haryana 122015
            </p>
          </div>
        </div>

        <table
          className="table-container"
          style={{ width: "100%", borderCollapse: "collapse" }}
        >
          <thead>
            <tr className="item-estimate1">
              <th rowSpan={2} style={{ border: "0.4px solid #6A6A6A" }} >
                S No.
              </th>
              <th rowSpan={2} style={{ border: "0.4px solid #6A6A6A" }}>
                Item & Description
              </th>
              <th
                rowSpan={2}
                style={{ border: "0.4px solid #6A6A6A", width: "12px" }}
              >
                HSN/SAC
              </th>
              <th
                rowSpan={2}
                style={{ border: "0.4px solid #6A6A6A", width: "24px" }}
              >
                Quantity
              </th>
              <th
                rowSpan={2}
                style={{ border: "0.4px solid #6A6A6A", width: "55px" }}
              >
                Rate
              </th>
              <th
                rowSpan={2}
                style={{ border: "0.4px solid #6A6A6A", width: "76px" }}
              >
                Taxable Amount
              </th>
              <th colSpan={2} style={{ border: "0.4px solid #6A6A6A" }}
              >
                CGST
              </th>
              <th colSpan={2} style={{ border: "0.4px solid #6A6A6A" }}>
                SGST
              </th>
              <th
                rowSpan={2}
                style={{ border: "0.4px solid #6A6A6A", width: "65px" }}
              >
                Total
              </th>
            </tr>
            <tr className=" item-estimate1">
              <th style={{ border: "0.4px solid #6A6A6A" }}>%</th>
              <th style={{ border: "0.4px solid #6A6A6A" }}>Amount</th>
              <th style={{ border: "0.4px solid #6A6A6A" }}>%</th>
              <th style={{ border: "0.4px solid #6A6A6A" }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr
                key={item.id}
                className="item-estimate"
                style={{
                  backgroundColor: index % 2 === 0 ? "#f5f2f8" : "white",
                }}
              >
                <td
                  style={{
                    borderLeft: "0.4px solid #6A6A6A",
                    borderRight: "0.4px solid #6A6A6A",
                    textAlign: "center",
                  }}
                >
                  {item.id}
                </td>
                <td>{item.description}</td>
                <td
                  style={{
                    borderLeft: "0.4px solid #6A6A6A",
                    borderRight: "0.4px solid #6A6A6A",
                    textAlign: "center",
                  }}
                >
                  {item.hsn}
                </td>
                <td style={{ textAlign: "center" }}>{item.qty}</td>
                <td
                  style={{
                    borderLeft: "0.4px solid #6A6A6A",
                    borderRight: "0.4px solid #6A6A6A",
                  }}
                ></td>
                <td style={{ textAlign: "center" }}>{item.amount}</td>
                <td
                  style={{
                    borderLeft: "0.4px solid #6A6A6A",
                    borderRight: "0.4px solid #6A6A6A",
                    textAlign: "center",
                  }}
                >
                  18%
                </td>
                <td style={{ textAlign: "center" }}>{item.gst}</td>
                <td
                  style={{
                    borderLeft: "0.4px solid #6A6A6A",
                    borderRight: "0.4px solid #6A6A6A",
                    textAlign: "center",
                  }}
                >
                  18%
                </td>
                <td></td>
                <td
                  style={{
                    borderLeft: "0.4px solid #6A6A6A",
                    borderRight: "0.4px solid #6A6A6A",
                    textAlign: "center",
                  }}
                >
                  {item.total}
                </td>
              </tr>
            ))}

            <tr className="item-estimate item-estimate-border-top">
              <td
                style={{
                  borderLeft: "0.4px solid #6A6A6A",
                  borderRight: "0.4px solid #6A6A6A"

                }}
                colSpan={5}
                className="colSpan5right"
              >
                Sub Total
              </td>
              <td ></td>
              <td
                style={{


                  borderLeft: "0.4px solid #6A6A6A"
                }}
                colSpan={2}
              >
                1
              </td>
              <td colSpan={2} style={{


                borderLeft: "0.4px solid #6A6A6A"
              }}></td>
              <td
                style={{
                  borderLeft: "0.4px solid #6A6A6A",
                  borderRight: "0.4px solid #6A6A6A",
                }}
              >
                18
              </td>
            </tr>

            {/*  */}
            <tr className="TrEstimatechangefont">
              <td
                className="td1"
                colSpan={5}
                style={{ borderRight: "0.4px solid #6A6A6A" }}

              >
                <div>Total In Words</div>
                <div style={{ marginTop: "-5PX" }}>
                  <span>Rupees Seventy Thousand Fifty-Eight Only</span>
                </div>
              </td>
              <td
                className="tdDiscount"
                colSpan={3}

              >
                Discount
              </td>
              <td
                className="tdDiscount1"
                colSpan={3}
                style={{ borderRight: "0.4px solid #6A6A6A" }}
              >
                0.90
              </td>
            </tr>

            <tr>
              <td className="tdDiscount3" colSpan={5} style={{ borderRight: "0.4px solid #6A6A6A" }}>
                Notes <br></br> <span>Looking forward for your business</span>
              </td>
              <td
                className="tdDiscount4"
                colspan={3}

              >
                Rounding <br></br> <span>Total</span>
              </td>
              <td
                className="tdDiscount5"
                colspan={3}
                style={{ borderRight: "0.4px solid #6A6A6A" }}
              >
                <span>0.90</span> <br /> <span style={{ fontWeight: '600' }}>#20,900.00</span>{" "}
              </td>
            </tr>
            <tr className="chefontmu">
              <td colSpan={2}>
                <table
                  style={{ width: "100%", lineHeight: "1", marginTop: "-29px" }}
                >
                  <tbody>
                    <tr className="fontweigthbold">
                      <td style={{ fontWeight: "bold" }}>For Payment in INR</td>
                    </tr>
                    <tr>
                      <td>
                        <hr
                          style={{
                            border: "0.4px solid #6A6A6A",
                            margin: "-1px 0px 3px 0",
                            width: "5rem",
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">BANK NAME:</span> ICICI
                        BANK
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">A/C NAME:</span> DBB
                        WORLD PVT LTD
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">A/C NO:</span>{" "}
                        1234567890
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">IFSC CODE:</span>{" "}
                        ICIC0001234
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">BRANCH:</span> LAXMI
                        NAGAR
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">SWIFT CODE:</span>{" "}
                        ICICINBBCTS
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <span></span>{" "}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td
                colSpan={3}
                style={{ borderLeft: "0.4px solid rgb(106, 106, 106)", borderRight: "0.4px solid rgb(106, 106, 106)", padding: "0 0 0 15px" }}
              >
                <table
                  style={{ width: "100%", lineHeight: "1", marginTop: "-10px" }}
                >
                  <tbody>
                    <tr>
                      <td
                        className="fontweigthbold"
                        style={{ fontWeight: "bold" }}
                      >
                        For Payment in AED
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <hr
                          style={{
                            borderTop: "0.4px solid rgb(106, 106, 106)",
                            borderBottom: "0.4px solid rgb(106, 106, 106)",
                            borderRight: "0.4px solid rgb(106, 106, 106)",
                            margin: "-1px 0px 3px 0",
                            width: "5.1rem",
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">ACCOUNT NAME:</span>{" "}
                        Carry My Pet Relocation Servies LLC
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">Bank NAME:</span>{" "}
                        Nttional Bank of Ras AI Khaimah
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">Account Type:</span>{" "}
                        Current Account
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">Account Number:</span>{" "}
                        098657897757861
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">IBAN:</span>{" "}
                        AE89777883098657897757861
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="fontweigthbold">Currency:</span> AED
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td
                colSpan={6}
                style={{
                  borderTop: "0.4px solid rgb(106, 106, 106)",
                  borderRight: "0.4px solid rgb(106, 106, 106)",
                  borderBottom: "0.4px solid rgb(106, 106, 106)",
                  textAlign: "center",
                  padding: "10px",
                }}
              >
                <div
                  className="imgdata34"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <span>For DBB Worldwide Pvt Ltd</span>

                  <img
                    src={image3}
                    alt="Signature"
                    style={{ margin: "0px 0", maxWidth: "134px" }}
                  />
                  <span>Authorized Signature</span>
                </div>
              </td>
            </tr>
            {/* Add more rows as needed */}
          </tbody>
        </table>

        <table
          className="table-container fixed-footer"
          style={{ width: "100%", textAlign: "center", marginTop: "80px" }}
        >
          <tbody style={{ background: "#5b489d", color: "white" }}>
            <tr>
              <td colSpan={3} style={{ padding: "0 6px 0 6px" }}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td
                        className="footer1"
                        style={{
                          width: "33.33%",
                          padding: "5px",
                          textAlign: "justify",
                        }}
                      >
                        <i
                          className="fas fa-envelope fasicon"
                          style={{ marginRight: "8px", color: "#ffffff" }}
                        ></i>
                        enquiry@carrymypet.com
                      </td>
                      <td
                        className="footer1"
                        style={{ width: "33.33%", padding: "5px" }}
                      >
                        <i
                          className="fa fa-phone"
                          style={{ marginRight: "8px", color: "#ffffff" }}
                        ></i>
                        +91 8908909020
                      </td>
                      <td
                        className="footer1"
                        style={{
                          width: "33.33%",
                          padding: "5px",
                          textAlign: "end",
                        }}
                      >
                        <i
                          className="fas fa-globe fasicon"
                          style={{ marginRight: "8px", color: "#ffffff" }}
                        ></i>
                        www.carrymypet.com <br /> www.carrymypet.ae
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        {" "}
        <button onClick={downloadAsPDF} className="download-button">
          Download as PDF
        </button>
      </div>
    </>
  );
};

export default Estimate1;
